/**
 * @generated SignedSource<<2db83f0d6e98c85ce0796c08663421a9>>
 * @relayHash 9ddfe114a50afa949f4990f2ed941cdb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6dd52c0077c978ee6624dccc12699b22d0e6f337cd12f1e2e931481b6494ff70

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { main_getIssueTransitionByIdRootQuery } from './main_getIssueTransitionByIdRootQuery.graphql';

import isLicenseCapabilitySetEnabled_provider from '@atlassian/jira-relay-provider/src/platform-forge-ui-license-capability-set.relayprovider';
import isUimAccessNarrowingEnabled_provider from '@atlassian/jira-relay-provider/src/uim-its-with-access-narrowing.relayprovider';

const node: PreloadableConcreteRequest<main_getIssueTransitionByIdRootQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "6dd52c0077c978ee6624dccc12699b22d0e6f337cd12f1e2e931481b6494ff70",
    "metadata": {},
    "name": "main_getIssueTransitionByIdRootQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcplatformforgeuilicensecapabilitysetrelayprovider": isLicenseCapabilitySetEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcuimitswithaccessnarrowingrelayprovider": isUimAccessNarrowingEnabled_provider
    }
  }
};

export default node;
